import { EntityType } from '@frontend/common';
import { DefaultSecondaryButton } from '@frontend/components/common';
import { CommonMessage } from '@frontend/lang';
import { SlotType } from '@frontend/slot/types';
import { FormattedMessage } from 'react-intl';

import { DefaultContainer } from '../../../../modal/detail-modal/default-container/default-container';
import { PlatformObjectBadge } from '../../../../modal/platform-object-badge/platform-object-badge.component';
import { useSlotsGrid } from './slots-grid.controller';

export interface SlotsGridProps {
    moduleId: string;
}

export const SlotsGrid = (props: SlotsGridProps) => {
    const viewProps = useSlotsGrid(props);

    return (
        <DefaultContainer
            title={CommonMessage.OBJECTS.SLOT.PLURAL}
            content={
                viewProps.isLoading ? (
                    <div className='text-brand-muted flex w-full items-center justify-center py-4'>{CommonMessage.FORMS.LOADING_PLACEHOLDER}</div>
                ) : viewProps.slots.length === 0 ? (
                    <div className='text-brand-muted flex w-full items-center justify-center py-4'>
                        <FormattedMessage
                            id='Terminal.Stock.Adjust-stock.no-slots'
                            description='Terminal Adjust stock no SLOTs found message'
                            defaultMessage='No SLOTs found'
                        />
                    </div>
                ) : (
                    <>
                        <div className='grid w-full grid-cols-3 gap-2.5 2xl:grid-cols-5'>
                            {viewProps.slots.map((slot) => (
                                <div
                                    key={slot.id}
                                    className='outline-brand-primary flex items-center justify-between rounded-md px-2.5 py-3.5 outline-1 -outline-offset-1'>
                                    <PlatformObjectBadge
                                        entityType={EntityType.SLOT}
                                        id={slot.id}
                                        display={slot.display ?? slot.index.toString()}
                                        parentIds={{
                                            spot_id: slot.spot_id,
                                            module_id: slot.module_id
                                        }}
                                    />
                                    <div className='flex flex-col gap-2.5'>
                                        {slot.type && slot.type === SlotType.TERMINAL && (
                                            <div className='bg-brand-muted flex items-center justify-center rounded-full px-2 py-1'>
                                                <span className='text-background-surface text-center text-sm font-semibold'>
                                                    <FormattedMessage
                                                        id='slots-grid.slot-type.terminal'
                                                        defaultMessage='Terminal'
                                                    />
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                        <DefaultSecondaryButton
                            text={CommonMessage.BUTTONS.VIEW_DETAILED_LIST}
                            onClick={() => viewProps.viewDetailedSlots(props.moduleId)}
                        />
                    </>
                )
            }
        />
    );
};
